module.exports = __webpack_public_path__ + "static/renaissance-62abc2d21f468effdf299a449c5ebfca.jpg";